// Link-only PDF pages (intentionally NOT in the navbar). Each key is a URL
// slug served at /<slug> (and /document/<slug>) by DocumentView; each file
// lives in client/public/docs/. Add a row here + drop the PDF in that folder
// to publish a new page.
const DOCUMENTS = {
  agenda: {
    file: "/docs/Target 2035 Symposium Program.pdf",
    title: "Target 2035 Symposium Program",
  },

  "aircheck-workshop": {
    file: "/docs/AIRCHECK Workshop Program.pdf",
    title: "AIRCHECK Workshop Program",
  },
  "career-panel": {
    file: "/docs/Career Panel.pdf",
    title: "Career Panel",
  },
  "promega-workshop": {
    file: "/docs/Promega Workshop.pdf",
    title: "Promega Workshop",
  },
};

export default DOCUMENTS;
